import { DomainProduct } from './types/product-types';

const STORAGE_KEY = 'msng3r_inventory_products_v1';

export function loadStoredProducts(): DomainProduct[] {
  if (typeof window === 'undefined' || !window.localStorage) return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as DomainProduct[]) : [];
  } catch {
    return [];
  }
}

export function syncStoredProducts(products: Iterable<DomainProduct>): void {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(products)));
  } catch {
    // Storage quota fallback
  }
}
